import { render } from 'base/wrapped-render-v2';
import { createRoot } from 'react-dom/client';
import { IdentityVerification } from './identity-verification.react';

const rootElement = document.createElement('div');
document.body.appendChild(rootElement);
const root = createRoot(rootElement);

export function renderIdentityVerification(props) {
	if (window.SESSION_USER) {
		render({
			children: <IdentityVerification {...props} />,
			root,
		});
	}
}
